import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// import dataL from "../../assets/json/vessel_details_8feb_11am.json";
import { map, filter, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
 providedIn: 'root'
})
export class trailService {

 private trailServiceMessage = new BehaviorSubject(null);
 currentApprovalStageMessage = this.trailServiceMessage.asObservable();
 baseUrl = environment.API_URL;
//  httpOptions = {
//     headers: new HttpHeaders({
//       'Content-Type':  'application/json',
//       "Access-Control-Allow-Origin": "*",
      
//     } ),responseType: 'text',
//   };
 fetchData(queryParams) {
  ///get/ship/trail/
    return this.http.get(this.baseUrl+"/shipTrailData/"+queryParams).pipe(map(res => {
        try{ 
          return (res); 
        } catch(e) {
          return e;
        }
      }))
  }
  fetchMapData(queryParams) {
    ///ship/trail/map/
    return this.http.get(this.baseUrl+"/shipMapTrailData/"+queryParams).pipe(map(res => {
        try{ 
          return (res); 
        } catch(e) {
          return e;
        }
      }))
  }
  fetchOtherRegionProbabilityData(queryParams) {
    return this.http.get(this.baseUrl+"/getOtherRegions",{params:queryParams}).pipe(map(res => {
        try{ 
          return (res); 
        } catch(e) {
          return e;
        }
      }))
  }
 constructor(private http: HttpClient) {

 }
 updateApprovalMessage(message: any) {
 this.trailServiceMessage.next(message)
 }
}